export enum Role {
  Resident = 'resident',
  Worker = 'worker',
  Installer = 'installer',
  Admin = 'admin',
  SuperAdmin = 'superadmin',
  Manager = 'manager',
  NonResident = 'nonResident',
}
